var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReport = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7295 4.46426e-08H4.5C2.84315 4.46426e-08 1.5 1.34315 1.5 3V21C1.5 22.6569 2.84315 24 4.5 24H18C19.6569 24 21 22.6569 21 21V7.233C20.9983 6.44506 20.6844 5.68991 20.127 5.133L15.9 0.9C15.3247 0.323668 14.5438 -0.000138815 13.7295 4.46426e-08ZM13.7295 1.5C14.1454 1.49928 14.5444 1.66449 14.838 1.959L19.0665 6.189C19.3456 6.46697 19.5017 6.84512 19.5 7.239V21C19.5 21.8284 18.8284 22.5 18 22.5H4.5C3.67157 22.5 3 21.8284 3 21V3C3 2.17158 3.67157 1.5 4.5 1.5H13.5H13.7295ZM4.5 18H18V19.5H4.5V18ZM7.5 10.5H6V16.5H7.5V10.5ZM9 6H10.5V16.5H9V6ZM13.5 10.5H12V16.5H13.5V10.5ZM15 9H16.5V16.5H15V9Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report.b51b4ce025e88ad545ce96afb4987b42.svg";